import { render, staticRenderFns } from "./IviewSwitch.vue?vue&type=template&id=59c5de2c&scoped=true&"
import script from "./IviewSwitch.vue?vue&type=script&lang=js&"
export * from "./IviewSwitch.vue?vue&type=script&lang=js&"
import style0 from "./IviewSwitch.vue?vue&type=style&index=0&id=59c5de2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5de2c",
  null
  
)

export default component.exports